// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"851f9bd4","1265":"40494ed5","2017":"362c5330","2380":"851f9bd4","2947":"11b01132","5628":"851f9bd4","6576":"6544a39c","7488":"851f9bd4","8089":"d702f99e"}[chunkId] + ".chunk.css";
};